import dayjs from 'dayjs';
import type { ParkSpaceOperationMode } from '@/services/bff/types/park';

export const SPACE_EXPIRING_DAYS = 30;

export type SpaceDisplayStatus =
  | 'occupied'
  | 'vacant'
  | 'self_use'
  | 'public'
  | 'non_operational';

export const spaceDisplayStatusText: Record<SpaceDisplayStatus, string> = {
  occupied: '已占用',
  vacant: '空置',
  self_use: '自用',
  public: '公共房源',
  non_operational: '不运营',
};

export const deriveSpaceDisplayStatus = (
  operationMode: ParkSpaceOperationMode | null | undefined,
  hasActiveOccupancy: boolean,
): SpaceDisplayStatus | null => {
  if (operationMode === 'leaseable')
    return hasActiveOccupancy ? 'occupied' : 'vacant';
  if (operationMode === 'self_use') return 'self_use';
  if (operationMode === 'public') return 'public';
  if (operationMode === 'non_operational') return 'non_operational';
  if (hasActiveOccupancy) return 'occupied';
  return null;
};

export const isOccupancyExpiring = (
  expectedEndDate?: string | null,
  now: dayjs.Dayjs = dayjs(),
): boolean => {
  if (!expectedEndDate) return false;
  const end = dayjs(expectedEndDate);
  if (!end.isValid()) return false;
  return (
    end.startOf('day').diff(now.startOf('day'), 'day') <= SPACE_EXPIRING_DAYS
  );
};
